import React, { useState, useEffect, useContext, useRef } from 'react';
import { PostRequest } from 'components/common/index.js';
import QuoteBuilderNavColumn from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderNavColumn.jsx'
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'
import resetSelectedListHandler from 'components/layout_and_quote_builder/quote_builder/resetSelectedListHandler.js'
import styles from 'components/layout_and_quote_builder/_style.module.scss';


// # has_many QuoteBuilderNavColumns
const QuoteBuilderNavSection = ({ config, noTitle, payload, presentedOptions, navSection, selectedList, setSelectedList, index }) => {
  const [items, setItems] = useState([]);
  const [totalInPence, setTotalInPence] = useState(0);
  const [hidden, setHidden] = useState(false);

  const getExtraItemsAction = (key_value, section_uuid, values, item, options) => {
    let user_quote_options = { user_quote_id: window.user_quote_id };
    let extraItemOptions = {
      is_item_extra: item.is_item_extra,
      extra_item_reason: item.extra_item_reason
    };

    let dataToPost = { ...{values}, ...{navSection}, ...options, extraItemOptions, ...{user_quote_options}, ...{key_value}, ... { material_attribute: values.material_attribute } };
    let filterFuncSame = (obj, index, self) => index === self.findIndex(t => JSON.stringify(t) === JSON.stringify(obj));
    let requesting_section_uuid = key_value.key + "@" + section_uuid + "@" + item.extra_item_reason + '';
    let queryMeta = `?query-name=extra_items&req=${requesting_section_uuid}&is_item_extra=${item.is_item_extra}&extra_item_reason=${item.extra_item_reason}&k=${JSON.stringify(key_value)}}`;

    PostRequest({
      url: `/quote-builder/extra-items/${requesting_section_uuid}/${item.uuid}/${item.extra_item_reason}${queryMeta}`,
      data: {
        options: dataToPost
      },
      callback: (data) => {
        let NoLongerInNewItemsFilter = (obj, index, self) => {
          let keep = true;
          if(obj.is_item_extra) {
            let foundInExtraItemsIndex = data.extra_items.findIndex(t => t.is_item_extra && t.extra_item_reason == obj.extra_item_reason && t.requesting_section_uuid == requesting_section_uuid);
            if(foundInExtraItemsIndex < 0 && obj.requesting_section_uuid == requesting_section_uuid) {
              keep = false;
            }
          }

          return keep;
        };

        setItems( (prev) => {
          return prev.concat(data.extra_items).filter(filterFuncSame).filter(NoLongerInNewItemsFilter);
        });

      }
    });
  };

  const getExtraItemsActionTimer = useRef();

  const getExtraItems = (key_value, section_uuid, values, item, options) => {
    if(getExtraItemsActionTimer.current != undefined) { clearTimeout(getExtraItemsActionTimer.current) }
    getExtraItemsActionTimer.current = setTimeout(() => { getExtraItemsAction(key_value, section_uuid, values, item, options); }, 500);
  }

  const sliceNumber = 2;

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  }

  const getSubSectionFromPart = (part) => {
    return part + ", ";
  }

  useEffect(() => {
    if(navSection.parts.length > 0) {
      navSection.parts.map((navSectionPart) => {
        payload.items.map((item) => {
          if(item.parts.indexOf(navSectionPart) > -1) {
            setItems((prev) => { return prev.concat(item).filter(onlyUnique) } )
          }
        })
      })
    } else {

      let checkMemberInPayload = (member) => {
        payload.items.map((item) => {
          if(item.uuid == member.uuid) {
            setItems((prev) => { return prev.concat(item).filter(onlyUnique) } );
          }});
      };

      navSection.members.map(checkMemberInPayload);
      navSection.sub_sections.map((subSection) => {
        subSection.members.map(checkMemberInPayload);
      });

      if(navSection.part_type == 'general') {
        setItems((_prev) => { return [navSection.drawing] } )
      }
    }

  }, []);

  // HOW WIDE THE SECTION FORM IS DRAWN. Its rows put the label on the left of the row and the control on the
  // right -- fine in the card an item's form is drawn in, about 709px wide, where the two still read as one
  // row. The SECTION's form is given whatever width its branch has instead, and when the section prices more
  // than one item (lamination adds a second) that branch is a colSpan=2 cell across both card columns: 1,465px,
  // which drew "Wastage count" and its input 1,211px apart (measured on quote 2691). Neither end of the row
  // looks like it belongs to the other. Holding the MULTI-COLUMN form to the card width puts the pair back
  // together without touching a single row -- same table, same alignment, same controls.
  //
  // The ONE-COLUMN branch is left at its full width instead. There the form shares its col-lg-8 with the
  // machine-columns table and the cost sections stacked below it (both fill that column), so a form capped
  // narrower than them sat visibly inset in the middle of the column -- three blocks in a stack at two widths.
  // Filling the column makes the form read at the SAME width as the table and the costs, and its one-item rows
  // are only ~950px apart, not the 1,465px the cap was for.
  //
  // /mcc only, like the rest of this tree's changes -- window.frank_mode is the page-mode flag this file's
  // neighbours already gate on (LayoutAndQuoteBuilderNavSection, QuoteBuilderNavColumn, LayoutSvg). The legacy
  // Manufacturing Cost Calculator is being left behind and keeps rendering exactly as it always has.
  const navSectionForm = () => {
    let item = items[0];

    const form = <QuoteBuilderForm
      config={config.nav_section}
      navSection={navSection}
      item={item}
      options={payload[item.uuid]}
      getExtraItems={getExtraItems}
      readOnly={window.user_quote_finalised}
    />

    if (!window.frank_mode) { return form; }

    // One item -> the one-column branch. Match the form to the machine-columns table and the cost sections
    // below it, which BOTH sit in a .quote_builder_container (10px padding) inside the same col-lg-8: give the
    // form that same container so it insets the identical 10px and lines up with them, edge for edge. Filling
    // the bare col-lg-8 instead left the form 10px wider on each side than the two blocks it stacks with.
    if (items.length === 1) { return <div className="quote_builder_container"> {form} </div>; }

    return <div className={styles.section_form_held_to_card_width}> {form} </div>
  }

const navSectionFormAndLabel = () => {
  // The general section has no section-level form of its own: its only field (wastage_count) is hidden for
  // 'general' (see the nav_section config's visible_if), so navSectionForm() renders an empty block. Skipping
  // it -- and the <br/> above it -- keeps that empty block from sitting between the section and its pricing
  // sub-sections and pushing them down out of line with the other form tabs. Applies to both the legacy (v1)
  // page and /mcc (Frank).
  const hideEmptyGeneralSectionForm = navSection.part_type === 'general';
  return (<div className="">
             { noTitle != true && (

              <div className="row">
                <div className="col-lg-12">

                  <br />

                  <div className="promo-block">
                    <div className="promo-text"> {navSection.label} </div>
                    <br />
                  </div>
                </div>
              </div>
              )}

              {!hideEmptyGeneralSectionForm && <br />}

              {!hideEmptyGeneralSectionForm && navSectionForm()}

            </div>)
}


 const handleClear = () => {
    resetSelectedListHandler({ index, setSelectedList });
  }

  const resetBtn1 = () => {
    if(window.user_quote_finalised) { return }
    if(setSelectedList == undefined) { return }
    return (<div className="row">
        <div className="col-lg-2"> </div>
          <div className="col-lg-8">
          <button className="btn btn-default" style={{"height" : "32px", "float": "right"}} onClick={handleClear} title={t('nav.back')} >
            <i className="zmdi zmdi-undo" onClick={handleClear}> </i> &nbsp; {t('nav.back')}
          </button>
        </div>
        <div className="col-lg-2"> </div>
      </div>)
  }

  const resetBtn2 = () => {
    if(window.user_quote_finalised) { return }
    // The same guard resetBtn1 carries: a caller that withholds setSelectedList (the /mcc Pricing tab, which
    // changes the choice through its own Manufacturing Line / Solution tabs) is asking for no "go back"
    // control. Without it the button rendered and handleClear called an undefined setter. It only became
    // reachable once the multi-item branch below started returning its markup.
    if(setSelectedList == undefined) { return }
    return (<div className="row">
          <div className="col-lg-12">
          <button className="btn btn-default" style={{"height" : "32", "float": "right"}} onClick={handleClear} title={t('nav.back')} >
            <i className="zmdi zmdi-undo" onClick={handleClear}> </i> &nbsp; {t('nav.back')}
          </button>
        </div>
      </div>)
  }


  const oneColumn = () => {
    let item = items[0];

    return (
      <div>
        <div className="row">
          <div className="col-lg-12 float-right">
          {navSectionFormAndLabel()}
          </div>
        </div>

        <QuoteBuilderNavColumn
          index={index}
          config={config}
          item={item}
          options={payload[item.uuid]}
          presentedOptions={presentedOptions[item.uuid]}
          setItems={setItems}
          navSection={navSection}
          getExtraItems={getExtraItems}
          colIndex={0}
          setSelectedList={setSelectedList}
          selectedList={selectedList}
        />
      </div>
    )
  }

  const moreColumns = () => {
    return (
       <div className="col-lg-12 newtabcontent navSectionContent">
        <table className={`quote_builder_table_2`}>
          <tbody>
           <tr>
              <td colSpan="2" valign="top" className="sectionTd">
                { navSectionFormAndLabel() }
              </td>
            </tr>

              {items.each_slice(sliceNumber).map((slice, sliceIndex) => {

                return (
                  <tr>
                    {slice.map((item, colIndex) => {
                      return <td valign="top" className="sectionTd">
                        <div className="card">

                           <QuoteBuilderNavColumn
                              index={navSection.index}
                              config={config}
                              item={item}
                              multipleColumns={true}
                              options={payload[item.uuid]}
                              presentedOptions={presentedOptions[item.uuid]}
                              setItems={setItems}
                              navSection={navSection}
                              setSelectedList={setSelectedList}
                              selectedList={selectedList}
                              colIndex={`${(sliceIndex * sliceNumber) + colIndex}`}
                            />
                        </div>

                      </td>
                    })}

                  {[...Array(sliceNumber - slice.length)].map(() => {
                    return <td> &nbsp; </td>
                  })}
                  </tr>
                )
              })}

          </tbody>
      </table>
     </div>
    )
  }

  const onTotalPriceInPenceSet = (msg) => {
    let detail = msg.detail;
    if(detail.label != navSection.label) { return }
    setTotalInPence( (prev) => prev + detail.total_price_in_pence )
  }

  MyEventListener([{
    key: 'total_price_in_pence_set',
    callback: onTotalPriceInPenceSet
  }])

  useEffect( () => {
    setHidden( () => window.user_quote_finalised && totalInPence == 0 )
  }, [totalInPence])

  if(items.length == 1) {
    return <>{resetBtn1()}<div className="row">
      <div className="col-lg-2"> </div>
      <div className={`col-lg-8 ${hidden ? 'hidden' : ''}`}> {oneColumn()} </div>
      <div className="col-lg-2"> </div>
    </div>
    </>
  }

  // MORE THAN ONE ITEM -- the section prices an extra item alongside its own (turning Lamination on adds a
  // `lamination_extra_item_one` for the same member, which QuoteBuilderNavColumn titles "Lamination").
  // This branch used to open a JSX fragment and put `return` INSIDE it, so the word was parsed as element
  // text: the fragment was built, thrown away, and the component fell through to return undefined -- every
  // multi-item section rendered as a blank page.
  if(items.length > 1) {
    return (<>{resetBtn2()}<div className="row">
      <div className={`col-lg-12 ${hidden ? 'hidden' : ''}`}> {moreColumns()} </div>
    </div></>)
  }

}

export default QuoteBuilderNavSection;
